import { render, staticRenderFns } from "./EditOrderFormOld.vue?vue&type=template&id=76afc84d&scoped=true"
import script from "./EditOrderFormOld.vue?vue&type=script&lang=js"
export * from "./EditOrderFormOld.vue?vue&type=script&lang=js"
import style0 from "./EditOrderFormOld.vue?vue&type=style&index=0&id=76afc84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76afc84d",
  null
  
)

export default component.exports